module.exports = __webpack_public_path__ + "assets/img/active_3.96db04e6.svg";